<template>
    <VMenu v-if="showSortSelect" :as="element" :class="containerClass">
        <div>
            <MenuButton class="group grid grid-flow-col justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                {{ i18n.sorting }}<b v-if="showSelectedOption">:&nbsp;{{ selectedSortTitle }}</b>
                <ChevronDownIcon
                    class="size-5 shrink-0 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                />
            </MenuButton>
        </div>
        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems class="absolute top-5 left-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black/5 focus:outline-none">
                <div class="py-3">
                    <MenuItem
                        v-for="(sort, sortIdx) in sorting"
                        :key="sortIdx"
                        v-slot="{ active, close }"
                    >
                        <a
                            :class="[selectedSort === prepareSorValue(sort) ? 'font-medium text-gray-900' : 'text-gray-500', active ? 'bg-gray-100 outline-none' : '', 'block cursor-pointer px-4 py-2 text-sm whitespace-nowrap']"
                            @click.prevent="close(); updateSorting(sort)"
                        >
                            {{ sort.title }}
                        </a>
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </VMenu>
</template>
<script>
import {
    Menu as VMenu,
    MenuItem,
    MenuButton,
    MenuItems,
} from "@headlessui/vue"

import {ChevronDownIcon} from "@heroicons/vue/20/solid"

export default {
    name: "DatasetSorting",
    components: {
        VMenu,
        MenuButton,
        MenuItems,
        MenuItem,
        ChevronDownIcon,
    },
    props: {
        sorting: {
            type: Array,
            required: true,
        },
        defaultSorting: {
            type: Object,
            required: true,
        },
        i18n: {
            type: Object,
            required: true,
        },
        showSelectedOption: {
            type: Boolean,
            default: true,
        },
        element: {
            type: String,
            required: true,
            default: "div",
        },
        containerClass: {
            type: String,
            default: "relative inline-block text-left",
        }
    },
    emits: ["update:sorting"],
    data: function () {
        return {
            selectedSort: "",
            selectedSortTitle: "",
        }
    },
    computed: {
        showSortSelect() {
            return this.sorting.length > 1
        }
    },
    created() {

        this.restoreSortingFromUrl()
    },
    methods: {

        restoreSortingFromUrl() {
            const params = new URLSearchParams(window.location.search)
            if (params.has("s")) {
                const s = params.get("s")
                const sort = this.sorting.find(sort => this.prepareSorValue(sort) === s)
                this.updateSorting(sort ? sort : this.defaultSorting)
            } else {
                this.updateSorting(this.defaultSorting)
            }
        },

        saveParameters() {
            const params = new URLSearchParams(window.location.search)
            params.delete("s")
            if (this.selectedSort) {
                params.append("s", this.selectedSort)
            }
            window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`)
        },

        updateSorting(sort) {
            this.selectedSort = this.prepareSorValue(sort)
            this.selectedSortTitle = sort.title
            this.saveParameters()
            this.$emit("update:sorting", this.selectedSort)
        },


        prepareSorValue(sort) {
            return sort.direction === "asc" ? sort.name : "-" + sort.name
        }
    }
}
</script>
